var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"aria-required":"true","options":_vm.options,"placeholder":_vm.placeholder,"multiple":"multiple","track-by":"name","label":"name"},on:{"select":_vm.reload,"remove":_vm.reload},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }